import React, { useState } from "react";
import { withMonogramContext } from "./MonogramContext";

const Range = ({ min = 0, max = 100, value, onChange, label }) => (
  <div>
    <input type="range" min={min} max={max} value={value} onChange={onChange} />
    <label htmlFor={label}>{label}</label>
  </div>
);
const DecorativeSvgCalibration = ({ svgBounds, chosenFont }) => {
  const { tempBounds, setTempBounds } = svgBounds;

  const [copied, setCopied] = useState(false);

  const handleBoundUpdate = (bound, axis, value) => {
    setTempBounds({
      ...tempBounds,
      [bound]: {
        ...tempBounds[bound],
        [axis]: Number(value),
      },
    });
  };

  const handleDimensionUpdate = (key, value) => {
    setTempBounds({
      ...tempBounds,
      [key]: Number(value),
    });
  };

  const handleCopy = () => {
    setCopied(true);
    navigator.clipboard.writeText(JSON.stringify(tempBounds));

    setTimeout(() => {
      setCopied(false);
    }, 1000);
  };

  return (
    <div className="monogram__deco-svg">
      <h4>Decorative SVG Calibration</h4>
      <p>X & Y Axis</p>
      <Range
        label={`X (${tempBounds.axis.x}%)`}
        value={tempBounds.axis.x}
        onChange={(e) => handleBoundUpdate("axis", "x", e.target.value)}
      />
      <Range
        label={`Y (${tempBounds.axis.y}%)`}
        value={tempBounds.axis.y}
        onChange={(e) => handleBoundUpdate("axis", "y", e.target.value)}
      />
      <p>Dimensions</p>
      <Range
        label={`Width (${tempBounds.width}%)`}
        value={tempBounds.width}
        onChange={(e) => handleDimensionUpdate("width", e.target.value)}
        max={100}
      />
      <Range
        label={`Height (${tempBounds.height}%)`}
        value={tempBounds.height}
        onChange={(e) => handleDimensionUpdate("height", e.target.value)}
        max={100}
      />
      <p>
        <strong>IMPORTANT!</strong> To save your selections above, copy the below value to the font
        settings product metafields for <i>{chosenFont.font_name}</i> in Accentuate.
      </p>
      <code
        style={{
          backgroundColor: "black",
          color: "white",
          borderRadius: "1rem",
          display: "block",
          marginBottom: "1rem",
          padding: "1rem",
        }}
      >
        {JSON.stringify(tempBounds)}
      </code>
      <button onClick={handleCopy}>{copied ? "Copied" : "Copy"}</button>
    </div>
  );
};

export default withMonogramContext(DecorativeSvgCalibration);
